.body {
  height: 200px;
  padding: 16px;
}

.warn-with-name {
  padding-bottom: 16px;
}

.list {
  padding-top: 8px;
  padding-left: 16px;

  li {
    padding-bottom: 4px;
    list-style-type: disc;
    display: list-item;
    line-height: 1.1;
    list-style-position: inside;
  }
}
